import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import packageInfo from '../../package.json';

let cachedInfo = null;

export async function getRuntimeAppInfo() {
  if (cachedInfo) return cachedInfo;
  const platform = Capacitor.getPlatform();
  if (Capacitor.isNativePlatform()) {
    try {
      const info = await CapacitorApp.getInfo();
      cachedInfo = {
        version: String(info?.version || packageInfo.version || 'unknown'),
        build: String(info?.build || ''),
        platform,
      };
      return cachedInfo;
    } catch {}
  }
  cachedInfo = { version: String(packageInfo.version || 'unknown'), build: '', platform: platform || 'web' };
  return cachedInfo;
}

export async function getRuntimeVersionLabel() {
  const info = await getRuntimeAppInfo();
  return info.build ? `${info.version} (${info.build})` : info.version;
}
